import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import WOW from "wowjs";
import Newsletter from './Newsletter';
import RecentBlog from './RecentBlog';

function Footer() {

    const [footers, setFooters] = useState([]); // Set the initial value to an empty array

    useEffect(() => {
        function header() {
            axios
                .get("https://solanthegroup.com/admin/api/footers")
                .then((response) => {
                    setFooters(response.data); // Set the fetched data
                })
                .catch((error) => {
                    // Handle error (e.g., log or show an error message)
                });
        }
        header();
    }, []);

    return (
        <div>
            {footers.length > 0 &&
                <>

                    {footers.length > 0 && footers.map((footer) => (
                        <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <Newsletter />
                                    </div>
                                </div>
                                <div className="footer-main footer-style-one">
                                    <div className="row g-5">
                                        <div className="col-lg-4 col-md-6">
                                            <div className="single-footer-wrapper border-right mr--20">
                                                <div className="logo">
                                                    <Link to="/">
                                                        <img src={`https://solanthegroup.com/admin/${footer.logo}`} alt="logo" style={{ width: "250px" }} />
                                                    </Link>
                                                </div>
                                                <p className="description">
                                                    {footer.description}
                                                </p>
                                                <div className="day-time">
                                                    <div className="icon">
                                                        <i className="fa-solid fa-alarm-clock" />
                                                    </div>
                                                    <div className="content">
                                                        <div className="day">{footer.days}</div>
                                                        <div className="time">{footer.times}</div>
                                                    </div>
                                                </div>
                                                <ul className="social-icons solid-social-icons rounded-social-icons">
                                                    <li>
                                                        <Link to={`${footer.facebook}`}>
                                                            <i className="fa-brands fa-facebook-f" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${footer.instagram}`}>
                                                            <i className="fa-brands fa-instagram" />
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={`${footer.twitter}`}>
                                                        <i className="fa-brands fa-linkedin-in" />
                                                        </Link>
                                                    </li>
                                                    
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-6">
                                            <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                                                <h5 className="ft-title">Quick Link</h5>
                                                <ul className="ft-link">
                                                    <li>
                                                        <Link to={'/About'}>About Company</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={'/TeamOne'}>Meet Our Team</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={'/Service'}>Our Services</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={'/Blog'}>News &amp; Media</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={'/Contact'}>Contact Us</Link>
                                                    </li>
                                                    <li>
                                                        <Link to={'/FaqOne'}>Support</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-6">
                                            <RecentBlog />
                                        </div>
                                        <div className="col-lg-3 col-md-6">
                                            <div className="single-footer-wrapper">
                                                <h5 className="ft-title">Official info:</h5>
                                                <ul className="ft-link">
                                                    <li className="ft-location">
                                                        {footer.address}
                                                    </li>
                                                    <li>
                                                        <div className="single-contact">
                                                            <div className="icon">
                                                                <i className="fa-solid fa-envelope-open-text" />
                                                            </div>
                                                            <div className="content">
                                                                <span>E-mail:</span>
                                                                <Link to={`mailto:${footer.email}`}>
                                                                    {footer.email}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="single-contact">
                                                            <div className="icon">
                                                                <i className="fa-light fa-phone" />
                                                            </div>
                                                            <div className="content">
                                                                <span>Phone:</span>
                                                                <Link to={`tel:${footer.phone}`}>{footer.phone}</Link>
                                                                <br />
                                                                <Link to={`tel:${footer.phone2}`}>{footer.phone2}</Link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </footer>
                    ))}
                    <div className="copyright-area-one">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="main-wrapper">
                                        <p>
                                            © Copyright 2024. All Rights Reserved by{" "}
                                            <a to="https://rcreation-bd.com/">RCreation</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default Footer